<template>
    <div class="swiper vitadio-life">
        <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="image in imagesForCarousel">
                <figure>
                    <img :src="image.media_url" alt="Vitadio people">
                    <a href="https://www.instagram.com/vitadio_life/" target="_blank">
                        <figure>
                            <svg width="64" height="63" viewBox="0 0 64 63" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_14248_32264)">
                                    <circle cx="31.6172" cy="31.5" r="25.5" fill="white"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M31.6172 0C49.0142 0 63.1172 14.103 63.1172 31.5C63.1172 48.897 49.0142 63 31.6172 63C14.2202 63 0.117188 48.8971 0.117188 31.5C0.117188 14.1029 14.2202 0 31.6172 0ZM23.9359 13.4872H39.2993C45.0687 13.4872 49.7867 18.1468 49.7867 23.8391V39.1611C49.7867 44.8547 45.0687 49.5128 39.2995 49.5128L23.9359 49.5126C18.1665 49.5126 13.448 44.8546 13.448 39.161V23.839C13.448 18.1468 18.1666 13.4873 23.9359 13.4873L23.9359 13.4872ZM31.5194 21.7736C37.1258 21.7736 41.6752 26.3231 41.6752 31.9294C41.6752 37.5357 37.1258 42.0853 31.5194 42.0853C25.9131 42.0853 21.3628 37.5364 21.3628 31.9294C21.3628 26.3224 25.9117 21.7736 31.5194 21.7736ZM31.5194 25.2039C35.232 25.2039 38.2452 28.2164 38.2452 31.9294C38.2452 35.6425 35.2319 38.6558 31.5194 38.6558C27.807 38.6558 24.7929 35.6425 24.7929 31.9294C24.7929 28.2164 27.8056 25.2039 31.5194 25.2039ZM41.3448 20.3658C42.2556 20.3658 42.994 21.1043 42.994 22.0141C42.994 22.924 42.2556 23.6633 41.3448 23.6633C40.434 23.6633 39.6965 22.9249 39.6965 22.0141C39.6965 21.1033 40.4349 20.3658 41.3448 20.3658ZM25.1914 16.4299H38.0451C42.8716 16.4299 46.8188 20.3577 46.8188 25.1575V38.0756C46.8188 42.8753 42.8716 46.8025 38.0451 46.8025L25.1914 46.8026C20.3649 46.8026 16.4169 42.8756 16.4169 38.0758V25.1573C16.4169 20.3576 20.3649 16.4298 25.1914 16.4298V16.4299Z" fill="url(#paint0_linear_14248_32264)"/>
                                </g>
                                <defs>
                                    <linearGradient id="paint0_linear_14248_32264" x1="43.9466" y1="53.0398" x2="18.2562" y2="9.50297" gradientUnits="userSpaceOnUse">
                                    <stop stop-color="#F58529"/>
                                    <stop offset="0.17" stop-color="#FEDA77"/>
                                    <stop offset="0.48" stop-color="#DD2A7B"/>
                                    <stop offset="0.78" stop-color="#8134AF"/>
                                    <stop offset="1" stop-color="#515BD4"/>
                                    </linearGradient>
                                    <clipPath id="clip0_14248_32264">
                                    <rect width="63" height="63" fill="white" transform="translate(0.117188)"/>
                                    </clipPath>
                                </defs>
                            </svg>
                        </figure>
                        <span>Check us on Instagram</span>
                    </a>
                </figure>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return {
            isFetching: true,
            imagesForCarousel: [],
        }
    },

    mounted() {
        let imagesFromApi = []
        const token = process.env.MIX_INSTAGRAM_ACCESS_TOKEN;
        const carousel = "CAROUSEL_ALBUM"
        const image = "IMAGE"
        const instance = axios.create()
        
        delete instance.defaults.headers.common['X-CSRF-TOKEN']
        delete instance.defaults.headers.common['X-Requested-With']

        instance
        .get(`https://graph.instagram.com/me/media?fields=media_url,media_type,timestamp&access_token=${token}`,
        )
        .then((res) => {
            imagesFromApi = res.data.data
            this.imagesForCarousel = imagesFromApi.filter(mediaType => mediaType.media_type === carousel || mediaType.media_type === image).slice(0, 10)
            !this.isFetching
        })
        .catch((e) => {
            console.log(e)
            !this.isFetching
        })
    },
}
</script>
